<template>
  <router-view />
</template>
<script>
export default {
  name: 'Tournaments',
};
</script>
